// extracted by mini-css-extract-plugin
export default {"seeAll":"AddTrademarkToCollectionModal_seeAll__n9f66"};